import { createStore, combineReducers } from 'redux'
import toDoApp from './reducers/todo'
import counter from './reducers/counter'

const rootReducer = combineReducers({
  counter: counter,
  todos: toDoApp,
})

// don't forget to add the extra counter sub-level to the mapStateToProps if combining as one reducer ! eg state.counter becomes state.counterCombinePartReducer.counter
export default createStore(rootReducer)
